import React from 'react';
import { Select } from 'antd';

import TransactionPublisherTable from './TransactionPublisherTable';
import TransactionPublisherRingChart from './TransactionPublisherRingChart';
import EntityBreakdownCard from '../../../../../../../shared/designSystem/components/EntityBreakdownCard';
import { prepareCTR } from '../../../../../../../../core/utils/campaigns';
import { MenuItemText } from '../../../../../../../shared/globalStyling/styledText';
import { getRingColor } from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// =============================================================================
// TransactionPublisherDetails (V1) — migrated from AntD Card / Row / Col to
// the shared `.campaign-overview__creatives` section vocabulary. Mirrors the
// V2 TransactionPublisherDetails shape.
//
// Upstream data shape preserved — accepts `transactionsPublishers` with V1's
// lowercase-ish keys (mediaSource, title, IMPRESSION_SITENAME, impressions,
// totalTransactions). Only the chrome changes.
// =============================================================================

const { Option } = Select;

const SHOW_BY_OPTIONS = [
  { value: 'impressions', text: 'Impressions' },
  { value: 'totalTransactions', text: 'Transactions' },
];

const TransactionPublisherDetails = ({
  transactionsPublishers,
  publisherDimension,
  setPublisherDimension,
}) => {
  if (!transactionsPublishers || transactionsPublishers.length === 0) return null;

  const formatTransactionData = transactionsPublishers.map((val) => ({
    imageUrl: val.mediaSource ? val.mediaSource : '',
    impressions: val.impressions,
    totalTransactions: val.totalTransactions,
    xAxis: val.title ? val.title : val.IMPRESSION_SITENAME,
  }));

  if (!formatTransactionData || formatTransactionData.length === 0) return null;

  const parsedData = prepareCTR(formatTransactionData);
  if (!parsedData || parsedData.length === 0) return null;

  const colorValuePairs = parsedData.map((el, index) => {
    if (el.xAxis) return { ...el, value: el.xAxis, color: getRingColor(index) };
    if (el.value) return { ...el, color: getRingColor(index) };
    return { ...el, value: `Creative ${index}`, color: getRingColor(index) };
  });

  if (!Array.isArray(colorValuePairs) || colorValuePairs.length === 0) return null;

  return (
    <EntityBreakdownCard
      title="Publishers"
      table={<TransactionPublisherTable publisherData={colorValuePairs} />}
      breakdownControl={
        <Select
          defaultValue={SHOW_BY_OPTIONS[0].value}
          onChange={(value) => setPublisherDimension(value)}
          getPopupContainer={(trigger) => trigger.parentNode}
          popupClassName="mjl-ds"
          className="campaign-overview__creatives-showby"
          size="small"
        >
          {SHOW_BY_OPTIONS.map((option) => (
            <Option key={option.value} value={option.value}>
              <MenuItemText text={option.text} />
            </Option>
          ))}
        </Select>
      }
      breakdownChart={
        <TransactionPublisherRingChart
          data={colorValuePairs}
          height={480}
          selectedPublisherDimension={publisherDimension}
        />
      }
    />
  );
};

export default TransactionPublisherDetails;
